import { getEnumValues } from "helpers/EnumsHelper";
import { InLieuOibPossibilities } from "helpers/RedirectHelper";
import { RoleType } from "modules/common";

export interface EPSignUpRequest {
    email: string;
    oib?: string;
    role: RoleType;
    token: string;
    returnUrl?: string;
}

export interface SignUpRequest {
    email: string;
    oib: string;
    countyId?: number;
    settlementId?: number;
    postalNumber?: string;
    street?: string;
    streetNumber?: string;
    returnUrl?: string;
}

export interface SignInRequest {
    username: string;
    password: string;
}

export interface EPSignInRequest {
    token: string;
    returnUrl?: string;
}

export interface ADSignInRequest {}

export interface LogOutRequest {
    token: string;
}

export enum ChangeNiasEntityRequestProperty {
    ForPersonOib = "forPersonOib",
    ForLegalIps = "forLegalIps",
    ForLegalIzvorReg = "forLegalIzvorReg",
    ToLegalIps = "toLegalIps",
    ToLegalIzvorReg = "toLegalIzvorReg",
}
export const changeNiasEntityRequestProperties = getEnumValues(ChangeNiasEntityRequestProperty);
export const changeNiasEntityRequestParameters: Record<ChangeNiasEntityRequestProperty, string> = {
    [ChangeNiasEntityRequestProperty.ForPersonOib]: "ForPersonOib",
    [ChangeNiasEntityRequestProperty.ForLegalIps]: "ForLegalIps",
    [ChangeNiasEntityRequestProperty.ForLegalIzvorReg]: "ForLegalIzvor_reg",
    [ChangeNiasEntityRequestProperty.ToLegalIps]: "ToLegalIps",
    [ChangeNiasEntityRequestProperty.ToLegalIzvorReg]: "ToLegalIzvor_reg",
};

export const changeNiasEntityRouteParameters = changeNiasEntityRequestProperties.reduce(
    (route, property) => {
        const parameter = `{${changeNiasEntityRequestParameters[property.value]}}`;
        return `${!route ? "" : `${route}/`}${property.enum}/${parameter}`;
    },
    ""
);

export interface ChangeNiasEntityRequest extends InLieuOibPossibilities {
    forLegalIzvorReg?: string;
    toLegalIzvorReg?: string;
}

export const parseChangeNiasEntityRequestFromRoute = (route: string) => {
    const segments = route.split("/");

    const data: ChangeNiasEntityRequest = {};
    for (let i = 0; i < segments.length; i += 2) {
        const property = changeNiasEntityRequestProperties.find(p => p.enum === segments[i])?.value;
        if (!property) continue;
        data[property] = segments[i + 1];
    }
    return data;
};
